// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.dashboard-container{display:block}}@media print{.dashboard-container .dashboard-section{display:block;height:auto}}.dashboard-container .dashboard-item{border:0.25em solid transparent;max-height:50%}@media screen and (min-width: 1024px){.dashboard-container .dashboard-item{height:100%}}@media print{.dashboard-container .dashboard-item{border:2px solid #000;border-radius:0.25em;width:100%}}\n", ""]);
// Exports
module.exports = exports;
